module.exports = {
    chatStarted: 'Chat started on {date}',
    chatJoin: '*** {name} joined the chat ***',
    chatClosed: '*** Chat has been closed ***'
};


// WEBPACK FOOTER //
// ./conversationTranscript/defaultLabels/en.js